import React from 'react';
import Section from './section';
import Providers from './providers';
import '../fragments/sections';

const Sections = ({ sections }) => (
  <Providers>
    {sections.filter(Boolean).map((section) => (
      <Section
        key={section.id}
        {...section}
      />
    ))}
  </Providers>
);

export default Sections;
